const asArray = (value: unknown): Record<string, unknown>[] => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(
    (row): row is Record<string, unknown> =>
      typeof row === "object" && row !== null
  );
};

export const extractNotificationsRowsFromApiData = (
  apiData: unknown
): Record<string, unknown>[] => {
  if (Array.isArray(apiData)) {
    return asArray(apiData);
  }

  if (typeof apiData !== "object" || apiData === null) {
    return [];
  }

  const root = apiData as Record<string, unknown>;

  if (Array.isArray(root.data)) {
    return asArray(root.data);
  }

  if (typeof root.data === "object" && root.data !== null) {
    const nested = root.data as Record<string, unknown>;

    if (Array.isArray(nested.data)) {
      return asArray(nested.data);
    }

    if (typeof nested.data === "object" && nested.data !== null) {
      const deepNested = nested.data as Record<string, unknown>;
      if (Array.isArray(deepNested.data)) {
        return asArray(deepNested.data);
      }
    }
  }

  return [];
};
